function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from 'react';
import './select.scss';
import { PropTypes } from 'prop-types';
export const Select = ({
  onChangeSelection,
  items = [],
  placeholder,
  valueKey,
  selectedKey,
  selected,
  autoselect,
  onReset
}) => {
  const _useState = useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        open = _useState2[0],
        setOpen = _useState2[1];

  const _useState3 = useState(placeholder),
        _useState4 = _slicedToArray(_useState3, 2),
        label = _useState4[0],
        changeLabel = _useState4[1];

  const itemsAndplaceholder = onReset && items ? [{
    [selectedKey || valueKey]: -1,
    name: placeholder
  }].concat(_toConsumableArray(items)) : items;

  const toggle = () => {
    setOpen(!open);
  };

  const onSelect = (id, item) => {
    if (item[selectedKey || valueKey] === -1) {
      changeLabel(placeholder);
      onReset();
    } else {
      onChangeSelection(id, item);
    }
  };

  useEffect(() => {
    if (items) {
      let selectItem = {
        [selectedKey || valueKey]: -1,
        name: placeholder
      };
      selectItem = items.find(pro => pro[selectedKey || valueKey] === selected) || {
        [selectedKey || valueKey]: -1,
        name: placeholder
      };
      changeLabel(selectItem.name);
    }
  }, [selected, items]);
  return React.createElement("div", {
    role: "presentation",
    className: open ? 'select select__open' : 'select',
    onClick: toggle
  }, React.createElement("div", {
    className: "selectLabel"
  }, React.createElement("span", {
    className: "selectLabelTxt"
  }, label)), React.createElement("ul", {
    className: "selectItems"
  }, itemsAndplaceholder && itemsAndplaceholder.map(item => React.createElement("li", {
    key: item.ineId,
    className: "selectItem",
    role: "presentation",
    onClick: () => onSelect(item[valueKey], item)
  }, item.name))));
};
Select.propTypes = {
  onChangeSelection: PropTypes.func.isRequired,
  // eslint-disable-next-line
  items: PropTypes.array,
  placeholder: PropTypes.string,
  valueKey: PropTypes.string
};
Select.defaultProps = {
  placeholder: 'Seleccione un elemento',
  valueKey: 'id',
  selected: 'all',
  items: []
};
export default Select;